export interface ISite {
    siteId: string;
    siteName: string;
    postcode: string;
    accessible: boolean;
}

export class Site implements ISite {
    siteId: string;
    siteName: string;
    postcode: string;
    accessible: boolean;

    constructor() {
        this.siteId = '';
        this.siteName = '';
        this.postcode = '';
        this.accessible = false;
    }
}
